<template>
  <list-layout class="list-layout" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">维修价格查询</span>
    <div class="tab" slot="btn_tabs">
      <el-tabs class="tab" :value="activename" @tab-click="handleTabClick">
        <el-tab-pane :disabled="IsLoading" label="标准维修" name="base"></el-tab-pane>
        <el-tab-pane :disabled="IsLoading" label="故障维修" name="repair"></el-tab-pane>
        <!--  <el-tab-pane label="翻新维修" name="waitqc"></el-tab-pane> -->
      </el-tabs>
    </div>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="品牌">
        <el-select class="form-input" filterable @change="changeBrand" clearable v-model="Search.BrandName" placeholder="请选择或输入品牌">
          <el-option v-for="item in BrandNames" :key="item.Name" :label="item.Name" :value="item.Name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机型">
        <el-select class="form-input" filterable clearable v-model="Search.ProductModel" placeholder="请选择或输入机型">
          <el-option v-for="item in ProductModels" :key="item.Name" :label="item.Name" :value="item.Name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块">
        <el-select class="form-input" filterable clearable v-model="Search.ProductModule" placeholder="请选择或输入模块">
          <el-option v-for="item in ProductModules" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" placeholder="请输入物料名称/物料编码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch">查询</el-button>
        <router-link :to="{name: 'NewRepair'}">
          <el-button type="primary">新建维修单</el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="tableData" style="width: 100%" slot="main-content">
      <el-table-column type="expand">
        <template scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <table class="expend_table">
              <tbody>
                <tr>
                  <td width="15%">无级别维修</td>
                  <td width="25%">不拆机维修，对主机进行清洁、调整和其他软件设置类操作</td>
                  <td>清洁、调整、重装、恢复出厂设置</td>
                </tr>
                <tr>
                  <td>无级别维修</td>
                  <td>解锁</td>
                  <td>解锁</td>
                </tr>
                <tr>
                  <td>0级维修</td>
                  <td>不拆机情况下对机械零部件维修或更换</td>
                  <td>不拆机情况下的机械零部件维修或更换比如电池后盖，外置天线等</td>
                </tr>
                <tr>
                  <td>1级维修</td>
                  <td>拆机维修：机械零部件更换</td>
                  <td>机械零部件：前壳组件、后壳组件、内置电池、TP组件、显示模组、听筒、扬声器、麦克风、振动器、摄像头、射频连接线、内置天线、按键、侧键、FPC、转轴等 PC：A/B/C/D壳件、SSD/硬盘、风扇/散热器件、USB小板/PCB组件、触控板、硬盘接口件/支架、内存（包换内存屏蔽盖）、WIFI模块（包换NGFF Holder）、LCD排线等；</td>
                </tr>
                <tr>
                  <td>2级维修</td>
                  <td>更换主板</td>
                  <td>更换主板</td>
                </tr>
              </tbody>
            </table>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="物料名称／编码" width="260">
        <template scope="props">
          <el-col>{{props.row.Product.Name}}</el-col>
          <el-col>物料编码：{{props.row.Product.Code}}</el-col>
        </template>
      </el-table-column>
      <el-table-column label="品牌">
        <template scope="props">
          {{props.row.Product.Brand.Name}}
        </template>
      </el-table-column>
      <el-table-column label="机型">
        <template scope="props">
          {{props.row.Product.Model.Name}}
        </template>
      </el-table-column>
      <el-table-column label="模块">
        <template scope="props">
          {{props.row.Product.Module.Name}}
        </template>
      </el-table-column>
      <el-table-column label="标准维修费" v-if="activename=='base'">
        <template scope="props">
          <span v-if="props.row.BasePrice !== 0">
          ¥ {{props.row.BasePrice}}</span>
          <span v-else>
            暂无报价
          </span>
        </template>
      </el-table-column>
      <el-table-column label="故障维修费" v-if="activename=='repair'">
        <template scope="props">
          <span v-if="props.row.RepairPrice !== 0">
          ¥ {{props.row.RepairPrice}}</span>
          <span v-else>
            暂无报价
          </span>
        </template>
      </el-table-column>
    </el-table>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/pages/Repair/ListLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        BrandName: null,
        ProductModel: null,
        ProductModule: null,
        Product: null,
      },
      OriginalOrderTypes: [
        { label: '入库单', value: 'InStockPicking' },
        { label: '租赁单', value: 'RentalOrder' },
        { label: '发货单', value: 'OutStockPicking' },
        { label: '内部调拨单', value: 'InternalStockPicking' },
        { label: '物流单', value: 'DeliveryOrder' },
        { label: '备用件退货单', value: 'DeliveryBackupReturn' },
        { label: '质检单', value: 'QcOrder' },
        { label: '租赁退货单', value: 'RentalReturnOrder' },
        { label: '租赁换货单', value: 'RentalExchangeOrder' },
        { label: '租赁维修单', value: 'RentalRepairOrder' },
        { label: '盘点单', value: 'InventoryOrder' },
        { label: '维修订单', value: 'RepairOrder' },
        { label: '维修单', value: 'RepairWorkOrder' },
        { label: '委外维修单', value: 'ExternalRepairWorkOrder' },
      ],
      IsLoading: false,
      activename: 'base',
      warehouseDate: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      RepairTypes: [
        { label: '租赁维修', value: 'rental' },
        { label: '委托维修', value: 'delegated' },
        { label: '代管维修', value: 'managed' },
        { label: '拆件维修', value: 'parts' },
      ],
      BrandNames: [],
      ProductModels: [],
      ProductModules: [],
      tableData: [
        // {
        //   ProductCode: '110000237',
        //   ProductName: '百叶窗防窥罩',
        //   BrandName: '三星',
        //   ModelName: 'SG-291',
        //   ModuleName: '遮版模块',
        //   Price: '99',
        // },
      ],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          },
        }],
      },
      sorts: ['日立', 'NCR', '迪堡', 'WINCOR', '运通', '御银', '富士通', '怡化', 'OKI', '东信', '恒银', '晓星', '新达通', '科堡', 'LG', 'NMD', '其他品牌'],  // 品牌用来排序的数组
    }
  },
  methods: {
    handleSearch() {
      this.IsLoading = true
      const Services = o('ProductRepairCost').expand('Product')
      let filters = []
      if (this.Search.BrandName) {
        filters.push(`contains(Product/Brand/Name, '${this.Search.BrandName}')`)
      }
      if (this.Search.ProductModel) {
        filters.push(`contains(Product/Model/Name, '${this.Search.ProductModel}')`)
      }
      if (this.Search.ProductModule) {
        filters.push(`Product/Module/Id eq ${this.Search.ProductModule}`)
      }
      if (this.Search.Product) {
        filters.push(`contains(Product/Name, '${this.Search.Product}')
          or
          contains(Product/Code, '${this.Search.Product}')`)
      }
      // 读取首页维修价格查询带过来的物料名称、编码【modifyby:zdx modifyon:2017-10-16】
      let pnames = this.$route.query.product
      if (pnames && pnames.length > 0) {
        let pnamearr = pnames.split(',')
        let _product = '('
        for (let i = 0; i < pnamearr.length; i++) {
          if (pnamearr[i].length > 0) {
            _product += `contains(Product/Name,'${pnamearr[i]}')
              or
              contains(Product/Code, '${pnamearr[i]}')`
            if (i < pnamearr.length - 1) {
              _product += ' or '
            }
          //   filters.push(`contains(Product/Name, '${pnamearr[i]}')
          // or
          // contains(Product/Code, '${pnamearr[i]}')`)
          }
        }
        _product += ')'
        console.log(_product)
        filters.push(_product)
      }
      // if (this.activename === 'all') {
      // } else if (this.activename === 'finished') {
      //   filters.push(`(State eq 'finished')`)
      // } else if (this.activename === 'waitreceipt') {
      //   filters.push(`(State eq 'receiving')`)
      // } else if (this.activename === 'cancelled') {
      //   filters.push(`(State eq 'cancelled')`)
      // }
      if (filters.length > 0) {
        Services.filter(filters.join(' and '))
      }
      Services.inlineCount()
      Services.skip((this.currentPage - 1) * this.pageSize)
      Services.top(this.pageSize)
      Services.get().then(({ data, inlinecount }) => {
        this.tableData = data
        this.total = inlinecount
      }).fail((error) => {
        this.$alert(error.message)
      }).finally(() => {
        this.IsLoading = false
      })
    },
    handleTabClick({ name }) {
      this.activename = name
      this.handleSearch()
    },
    handleChange(page) {
      this.currentPage = page
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.handleSearch()
    },
    initBrandNames: function() {
      const BrandName = o('ProductBrand')
      BrandName.get().then((data) => {
        // 按顺序遍历品牌排序名数组
        this.sorts.forEach(function(item) {
          // 遍历返回的品牌的集合，找到了遍历的品牌则插入到品牌集合中
          data.data.forEach(function(item2, index) {
            if (item2.Name === item) {
              this.BrandNames.push(item2)
              // 添加进集合后移除掉已经添加的品牌
              data.data.splice(index, 1)
            }
          }, this)
        }, this)
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    // 当选择品牌后根据品牌名对机型进行二级联动
    changeBrand: function(brandName) {
      // 如果有选中品牌则给初始化机型方法传入品牌名字参数，没有则重新初始化
      if (brandName) {
        this.initProductModel(brandName)
      } else {
        this.initProductModel()
      }
    },
    initProductModel(brandName) {
      this.ProductModels = []
      let ProductModel = o('ProductModel')
      if (brandName) {
        ProductModel.filter(`contains(Name, '${brandName}')`)
      }
      ProductModel.get().then((data) => {
        // 当有品牌名传入则进行联动排序
        if (brandName) {
          // 根据查询到的排序级别排序.从1开始,找到对应的级别的机型push集合中。遍历结束后push剩下的机型
          const count = data.data.length
          for (let i = 1; i <= count; i++) {
            // 找到对应的排序级别机型
            const insertItem = data.data.find((_) => _.Sort === i)
            // 如果没有该排序级别则不添加
            if (insertItem) {
              this.ProductModels.push(insertItem)
              // 获取到该机型在原数组中的下标，根据下标移除
              const removeIndex = data.data.findIndex(_ => _.Code === insertItem.Code)
              data.data.splice(removeIndex, 1)
            }
          }
          // 添加剩下的机型
          // data.data.forEach(function(item, index) {
          //   this.ProductModels.push(item)
          // }, this)
        } else {
          this.ProductModels = data.data
        }
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    initProductModule() {
      const ProductModule = o('ProductModule')
      ProductModule.get().then((data) => {
        this.ProductModules = data.data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
  },
  components: {
    ListLayout,
    ComplexGrid,
  },
  created() {
    this.handleSearch()
    this.initBrandNames()
    this.initProductModel()
    this.initProductModule()
    // 如果有模块ID传入则加载该模块的所有维修价格
    if (this.$route.query.moduleId) {
      this.Search.ProductModule = this.$route.query.moduleId
    }
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}

.main-content {
  .tab {
    .el-tabs__active-bar {
      background-color: rgba(0, 0, 0, 0);
    }
  }
}

.expend_table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fbfdff;
  td {
    background-color: #fbfdff;
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// RepairPricePage.vue?92da255c